export default function compactObject(obj: any): any {
  const compact = obj
  Object.keys(obj).forEach((key) => {
    if (compact[key] === undefined || compact[key] === null) {
      delete compact[key]
    }
  })
  return obj
}
